import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "background-gradient" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", null, "You have not added any friends yet!", -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 💩 ")
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_FriendCell = _resolveComponent("FriendCell")!
  const _component_CellGroup = _resolveComponent("CellGroup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Header, {
      title: "Friends",
      backLink: _ctx.PROFILE_ROUTE
    }, null, 8, ["backLink"]),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.sortedFriends.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_CellGroup, null, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedFriends, (friend) => {
                  return (_openBlock(), _createBlock(_component_FriendCell, {
                    key: friend.id,
                    friend: friend,
                    shouldDisplayUsername: true
                  }, null, 8, ["friend"]))
                }), 128))
              ]),
              _: 1
            })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_7))
    ])
  ]))
}